<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.gradient-text-one {
  background-image: -webkit-linear-gradient(#85fdff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#202027' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;border-bottom: 1px #636363 solid;padding: 10px;" :style="{ 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC' }">
      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
        <p class="gradient-text-one" style="font-size: 18px;font-weight: 600;line-height: 22px;">
          {{ $t("shengchanshujufenxi") }}
        </p>
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }" style="padding:10px">
      <div id="manufaturingAnalySisPieChart" style="flex:1;" :style="{ height: contentHeight - 20 + 'px' }"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_manufacturing_analysis",
  components: {},
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    },
  },
  data() {
    return {
      chart: null,
      option: null,
      timer: null,
      contentHeight: 0,
      lists: [],
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 300000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get("/web/report/page/zhinengzhizao_shegnchanshujufenxi?getOrgByParent=orgId", {
        params: {
          orderBy: "dateTimeStr",
          orgId: this.$attrs.orgId,
        },
      });
      this.lists = response.data.rows;

      if (!this.chart) {
        this.initChart();
      }

      let datas = this.lists.map((item) => {
        return { name: (item.dateTimeStr + "")[4] + (item.dateTimeStr + "")[5] + this.$t("yue"), value: item.v >= 0 ? item.v : 0 };
      });
      this.chart.setOption({
        series: [
          {
            data: datas,
          },
        ],
      });

      this.resize();
    },

    initChart() {
      this.option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "right",

          textStyle: {
            fontSize: 10,
            color: "#FFFFFF", // 图例文字颜色
          },
        },
        // color: ["#634DFE", "#FB9738", "#27DFF2", "#FB9D9D", "#FB1266", "#2199FC", "#fc8251", "#5470c6", "#9A60B4", "#ef6567", "#f9c956", "#3BA272"],
        series: [
          {
            name: this.$t("chanliang"),
            type: "pie",
            center: ["25%", "50%"],
            radius: "80%",
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      };

      var chartDom = document.getElementById("manufaturingAnalySisPieChart");
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }

        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight;
        if (this.chart) {
          this.chart.getDom().style.height = this.contentHeight;
          this.chart.resize();
        }
      }, 800);
    },
  },
};
</script>
